const SwiperLoopMixin = {
  methods: {
    removeSwiperLoopImageLoading() {
      // swiper loop 简单复制DOM
      // 导致image 组件无法触发loaded 事件
      if (this.$refs.swiper) {
        const $wrapper = this.$refs.swiper.swiper.$wrapperEl[0];
        const SPECIAL_SWIPER_SLIDE_NODE_CLASS = 'swiper-slide-duplicate';
        const IMAGE_COMPONENT_CLASS = 'ym-image';
        const IMAGE_COMPONENT_LOADING_CLASS = 'ym-image-loading';
        const $duplicateItem = $wrapper.querySelectorAll(`.${SPECIAL_SWIPER_SLIDE_NODE_CLASS}`);
        Array.from($duplicateItem).forEach(($item) => {
          const $image = $item.querySelector(`.${IMAGE_COMPONENT_CLASS}`);
          const $loading = $image && $image.querySelector(`.${IMAGE_COMPONENT_LOADING_CLASS}`);
          if ($image && $loading) {
            $image.removeChild($loading);
          }
        });
      }
    },
  },
  mounted() {
    this.removeSwiperLoopImageLoading();
  },
  updated() {
    this.$nextTick(() => {
      this.removeSwiperLoopImageLoading();
    });
  },
};

export default SwiperLoopMixin;
